import { QuebecOperationCost } from '../operation-cost'

export const OperationCost = {
  ...QuebecOperationCost,
} as const
